
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import SectionTitle from '../../components/SectionTitle/SectionTitle';
import Navbar from '../../components/Navbar/Navbar';
import ContactForm from '../../components/ContactForm/ContactForm';
import Footer from '../../sections/Footer/Footer';
import WhatsAppContact from '../../sections/WhatsApp/WhatsAppContact';
import './Contactus.scss';

const Contactus = () => {
    const { t } = useTranslation();

    useEffect(() => {
        document.title =
            'Zahnarzt Bielefeld – Kontakt & Termin | Pankraz & Lichagin';

        document
            .querySelector('meta[name="description"]')
            ?.setAttribute(
                'content',
                'Kontakt zur Zahnarztpraxis Pankraz & Lichagin in Bielefeld-Milse. Adresse, Kontaktformular und Informationen zur Terminvereinbarung.'
            );
    }, []);

    return (
        <>
            <Navbar />

            {/* Separater WhatsApp-Bereich */}
            <WhatsAppContact />

            {/* Kontaktinformationen und Terminvereinbarung */}
            <section className="section-bg section-common contact-section">
                <SectionTitle
                    title={t('contactPage.title')}
                    description={t('contactPage.description')}
                />

                <div className="contact-options">
                    <p className="contact-options-text">
                        {t('contactPage.appointmentText')}
                        <br />
                        {t('contactPage.appointmentTextSecond')}
                    </p>

                    <div className="theme-btn">
                        <a
                            href="https://dr-flex.de/embed?medicalPracticeId=53366"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {t('contactPage.appointmentButton')}
                        </a>
                    </div>

                    <p className="contact-form-text">
                        {t('contactPage.formText')}
                        <br />
                        {t('contactPage.formTextSecond')}
                    </p>
                </div>
            </section>

            {/* Kontaktformular als eigener Bereich */}
            <section
                className="contact-form-area"
                data-aos="fade-up"
                data-aos-duration="2000"
            >
                <ContactForm />
            </section>

            <Footer />
        </>
    );
};

export default Contactus;
